/**
 * @generated SignedSource<<4354a0a25e7855abb729235808f35e4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ForumTopicCreatePageQuery$variables = {
  slug: string;
};
export type ForumTopicCreatePageQuery$data = {
  readonly forumBySlug: {
    readonly guidelines: string | null | undefined;
    readonly id: string;
    readonly owner: {
      readonly id: string;
    };
    readonly slug: string;
  } | null | undefined;
};
export type ForumTopicCreatePageQuery = {
  response: ForumTopicCreatePageQuery$data;
  variables: ForumTopicCreatePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guidelines",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForumTopicCreatePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Forum",
        "kind": "LinkedField",
        "name": "forumBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForumTopicCreatePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Forum",
        "kind": "LinkedField",
        "name": "forumBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8614259c4e7c17144e4452dcca6404af",
    "id": null,
    "metadata": {},
    "name": "ForumTopicCreatePageQuery",
    "operationKind": "query",
    "text": "query ForumTopicCreatePageQuery(\n  $slug: String!\n) {\n  forumBySlug(slug: $slug) {\n    id\n    slug\n    guidelines\n    owner {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c97d580d3c276e54fbf1b1e933d627ff";

export default node;
